import { render, staticRenderFns } from "./ReviewsCategoriesSummary.vue?vue&type=template&id=64b40b6e&scoped=true&"
import script from "./ReviewsCategoriesSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesSummary.vue?vue&type=style&index=0&id=64b40b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b40b6e",
  null
  
)

export default component.exports